module.exports = __webpack_public_path__ + "plugins/web/img/cmdinfo-index2.80a69719.png";